import {
  Box,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  useTheme,
  Icon,
  useBoolean,
  Portal,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NoHTMLScroll from '../../../../../../common/src/components/NoHTMLScroll';

interface Props {
  onEdit: () => void;
  onRemove: () => void;
}

const TableActionsMenu: React.FC<React.PropsWithChildren<Props>> = ({
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [isHovering, setIsHovering] = useBoolean();

  return (
    <>
      <NoHTMLScroll />
      <Box onClick={(e) => e.stopPropagation()}>
        <Menu isLazy>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            onMouseEnter={setIsHovering.on}
            onMouseLeave={setIsHovering.off}
            icon={
              <Icon
                name="IconOthersFilled"
                color={isHovering ? 'white' : colors.gray[400]}
                boxSize={6}
              />
            }
            bgColor="gray.strokeAndBg"
            size="sm"
          />
          <Portal>
            <MenuList>
              <MenuItem
                icon={<Icon name="GeneralActionsEdit" />}
                onClick={onEdit}
              >
                {t('EDIT')}
              </MenuItem>
              <MenuItem
                color="danger.main"
                icon={<Icon name="GeneralActionsThrash" />}
                onClick={onRemove}
              >
                {t('REMOVE')}
              </MenuItem>
            </MenuList>
          </Portal>
        </Menu>
      </Box>
    </>
  );
};

export default TableActionsMenu;
